module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/dividers/divider-3-4e2447b3aad29b8bc64239cc21d715f3.svg";